import { render } from "./SurveyQuestionSelect.vue?vue&type=template&id=d8a2cb8a&scoped=true"
import script from "./SurveyQuestionSelect.vue?vue&type=script&lang=js"
export * from "./SurveyQuestionSelect.vue?vue&type=script&lang=js"

import "./SurveyQuestionSelect.vue?vue&type=style&index=0&id=d8a2cb8a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d8a2cb8a"

export default script